import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import moment, { Moment } from "moment";
import { IExpeditionSlot, IExpedition, AppointmentStatus, IExpeditionDay, ITransporter, IExpeditionInit, IOtherAppointment, IOtherAppointmentSlot, IExpeditionDock, IPermission } from "@/models";
import vSelect from "vue-select";
import { ExpeditionInit, OtherAppointmentEdit } from "@/components";

@Component({
    name: "ExpeditionDashboard",
    components: {
        "expedition-init": ExpeditionInit,
        "v-select": vSelect,
        "otherappointment-edit": OtherAppointmentEdit,
    },
})

export default class ExpeditionDashboard extends Vue {
    @Prop({ required: true })
    public date: Moment;

    public readonly createExpeditionModal: string = "createExpeditionModal";

    public showEditMeetingModal: boolean = false;

    public selectedTransporter: ITransporter = null;

    public selectedDate: Moment = null;
    public selectedDock: number = 0;

    public showModal: boolean = false;

    public currentExpedition: IExpedition;

    public occurence: number;

    constructor() {
        super();
    }

    public mounted(): void {
        let done = false;
        for (let i = 0; i <= this.slotCount; i++) {
            const timeCell = moment().hour(this.startHour).minute(this.startMinute).add(15 * i, "m");
            if (moment().diff(timeCell) < 0) {
                this.$scrollTo(`#time${i - 1}`, 500, {
                    container: ".dashboard-body",
                });
                done = true;
                break;
            }
        }
        if (!done) {
            this.$scrollTo("#time17", 500, {
                container: ".dashboard-body",
            });
        }
    }

    public get startSlotId(): number {
        return this.$store.state.expeditions.expeditionStartSlot.slotId;
    }

    public get startHour(): number {
        return moment(this.$store.state.expeditions.expeditionStartSlot.startTime, "HH:mm:ss").hour();
    }

    public get startMinute(): number {
        return moment(this.$store.state.expeditions.expeditionStartSlot.startTime, "HH:mm:ss").minute();
    }

    public get endSlotId(): number {
        return this.$store.state.expeditions.expeditionEndSlot.slotId;
    }

    public get slotCount(): number {
        return this.endSlotId - this.startSlotId + 1;
    }

    public get expeditionDay(): IExpeditionDay {
        return this.$store.getters["expeditions/getExpeditionDay"]();
    }

    public get otherAppointments(): IOtherAppointmentSlot[] {
        if (this.expeditionDay) {
            return this.$store.getters["otherAppointments/getOtherAppointmentByDays"](this.expeditionDay.day);
        }
        return this.$store.getters["otherAppointments/getOtherAppointments"]();
    }

    public get permission(): IPermission {
        return this.$store.state.user.permission;
    }

    public lookupOtherAppointment(slotId: number): boolean {
        slotId += this.startSlotId; // += 16 car 16 est l'id du slot de départ (TO DO : recuperer depuis table de parametrage)

        return this.otherAppointments.some(x => x.slotId === slotId);
    }

    public lookupDock(dock: number): boolean {
        this.currentExpedition = null;
        return this.expeditionDay.docks.some(x => x.dock === dock);
    }

    public getOtherAppointment(slotId: number): IOtherAppointmentSlot {
        slotId += this.startSlotId;

        return this.otherAppointments.find(x => x.slotId === slotId);
    }

    public lookupExpedition(dock: number, slotId: number): boolean {
        slotId += this.startSlotId;

        return this.expeditionDay.docks.find(x => x.dock === dock).expeditions.some(x => x.slotId === slotId);
    }

    public lookupCurrentExpedition(): boolean {
        if (this.currentExpedition != null && this.occurence < 3) {
            this.occurence++;
            return true;
        }
        else {
            return false;
        }
    }

    public getExpedition(dock: number, slotId: number): IExpedition {
        slotId += this.startSlotId; // += 31 car 31 est l'id du slot de départ (TO DO : recuperer depuis table de parametrage)

        this.occurence = 0;
        this.currentExpedition = this.expeditionDay.docks.find(x => x.dock === dock).expeditions.find(x => x.slotId === slotId);
        return this.currentExpedition;
    }

    public getCurrentDesign(slotId: number): string {
        let classes: string = "";
        if (moment(this.expeditionDay.day).isSame(moment(), "day")) {
            const time = moment().hour(this.startHour).minute(this.startMinute).add(15 * (slotId + 1 - this.occurence), "m");
            if (moment().diff(time) > 0 && this.currentExpedition.status === AppointmentStatus.Waiting) {
                classes += "passed late";
            }
            else if (this.currentExpedition.status === AppointmentStatus.InProgress) {
                classes += "in-progress";
            }
            else if (this.currentExpedition.status === AppointmentStatus.Done) {
                classes += "done";
            }
            else if (this.currentExpedition.status === AppointmentStatus.PendingValidation) {
                classes += "pending-validation";
            }
            else if (moment().diff(time) < 0) {
                classes += "";
            }
        }

        classes += ` class${this.occurence}`;

        return classes;
    }

    public getDesign(dock: number, slotId: number) {
        let classes: string = "";
        const expedition = this.getExpedition(dock, slotId);

        if (expedition != null) {
            if (expedition.status === AppointmentStatus.InProgress) {
                classes += "in-progress ";
            }
            else if (expedition.status === AppointmentStatus.Done) {
                classes += "done ";
            }
            else if (expedition.status === AppointmentStatus.PendingValidation) {
                classes += "pending-validation ";
            }
        }

        if (moment(this.expeditionDay.day).isSame(moment(), "day")) {
            const time = moment().hour(this.startHour).minute(this.startMinute).add(15 * (slotId + 1), "m");
            if (moment().diff(time) > 0 && expedition != null && expedition.status === AppointmentStatus.Waiting) {
                classes += "passed late";
            } else if (moment().diff(time) > 0) {
                classes += "passed";
            }
        }
        return classes;
    }

    public getDesignNoData(dock: number, slotId: number): string {
        if (moment(this.expeditionDay.day).isSame(moment(), "day")) {
            const time = moment().hour(this.startHour).minute(this.startMinute).add(15 * (slotId + 1), "m");
            if (moment().diff(time) > 0) {
                return "passed";
            } else {
                return "";
            }
        }
        else {
            return "";
        }
    }

    public getTimeLine(index): string {
        return moment().hour(this.startHour).minute(this.startMinute).add(15 * (index), "m").format("HH:mm");
    }

    public createExpedition(expedition: IExpedition): void {
        this.$store.commit("expeditions/SET_SELECTED_EXPEDITION", expedition);
        this.$router.push({ name: "ExpeditionCreate" });
    }

    public addExpedition(dock: number, index: number): void {
        this.selectedDock = dock;
        this.selectedDate = this.date.hour(this.startHour).minute(this.startMinute).add(15 * index, "m");
        this.showModal = true;
    }

    public validateInitExpedition(): void {
        const initExpedition: IExpeditionInit = {
            dock: this.selectedDock,
            expectedArrival: this.selectedDate.format("YYYY-MM-DD HH:mm"),
            transporter: this.selectedTransporter,
        };

        this.$store.dispatch("expeditions/initExpedition", initExpedition).then(() => {
            this.$modal.hide(this.createExpeditionModal);
            this.selectedTransporter = null;
        });
    }

    public showExpedition(dock: number, slotId: number): void {
        slotId += this.startSlotId;

        const expedition: IExpedition = this.expeditionDay.docks.find(x => x.dock === dock).expeditions
            .find(x => x.slotId === slotId || x.slotId === slotId - 1 || x.slotId === slotId - 2 || x.slotId === slotId - 3);

        this.$store.dispatch("expeditions/setSelectedExpedition", expedition);

        if ((expedition.isArrived && expedition.effectiveArrival !== null) ||
            (expedition.isArrived && expedition.type === 3)) {
            this.$router.push({ name: "ExpeditionCard" });
        }
        else if (expedition.isArrived) {
            this.$router.push({ name: "ExpeditionCreate" });
        }
        else {
            this.$router.push({ name: "ExpeditionCard" });
        }
    }

    public closeModal(): void {
        this.showModal = false;
    }

    public openEditMeetingModal(meeting: IOtherAppointmentSlot) {
        this.$store.commit("otherAppointments/SET_SELECTED_OTHER_APPOINTMENT", meeting);

        this.showEditMeetingModal = true;
    }

    public eventOtherAppoinement(): void {
        this.showEditMeetingModal = false;
    }
}
